


function incrementWithLeadingZeros(value, length) {
    // Convert the string to a number and increment it
    let incrementedValue = parseInt(value, 10) + 1;
    
    // Convert the incremented number back to a string
    let incrementedString = incrementedValue.toString();
  
    // Pad the string with leading zeros to maintain the desired length
    return incrementedString.padStart(length, '0');
  };


module.exports = incrementWithLeadingZeros;